module.exports = __webpack_public_path__ + "SamsungSharpSans-Regular.ffe0b35f802daceda190.ttf";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/SamsungSharpSans-Regular.ttf
// module id = ../../../../../src/assets/layout/fonts/SamsungSharpSans-Regular.ttf
// module chunks = styles